export { useWindowVariant } from './variants/useWindowVariant';
